/// <amd-module name="SuiteCommerce.Blog.DataProvider"/>
define("SuiteCommerce.Blog.DataProvider", ["require", "exports", "SuiteCommerce.Blog.DataProviderEntities.Model", "SuiteCommerce.Blog.DataProvider.File.Collection", "SuiteCommerce.Blog.Common.Configuration", "SuiteCommerce.Blog.Instrumentation"], function (require, exports, DataProvider_Model_1, DataProvider_File_Collection_1, Configuration_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DataProviderController = /** @class */ (function () {
        function DataProviderController() {
            this.entitiesModel = new DataProvider_Model_1.DataProviderModel();
            this.files = new DataProvider_File_Collection_1.FileCollection();
        }
        Object.defineProperty(DataProviderController, "instance", {
            get: function () {
                if (!this.dataProviderInstance) {
                    this.dataProviderInstance = new DataProviderController();
                }
                return this.dataProviderInstance;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DataProviderController.prototype, "categories", {
            get: function () {
                return this.entitiesModel.categories;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DataProviderController.prototype, "authors", {
            get: function () {
                return this.entitiesModel.authors;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DataProviderController.prototype, "terms", {
            get: function () {
                return this.entitiesModel.terms;
            },
            enumerable: true,
            configurable: true
        });
        DataProviderController.prototype.fetchEntitiesData = function () {
            var _this = this;
            this.entitiesModel.isSync = false;
            var loaderRequest = Instrumentation_1.default.getLog('loaderRequest');
            loaderRequest.startTimer();
            this.entitiesModel
                .fetch({ data: { siteId: Configuration_1.Configuration.siteId } })
                .done(function () {
                _this.entitiesModel.isSync = true;
                loaderRequest.endTimer();
                loaderRequest.setParameters({
                    activity: 'Entities Loader Request',
                    totalTime: loaderRequest.getElapsedTimeForTimer(),
                });
                loaderRequest.submit();
                _this.createLogForEntityLoaded('Authors', _this.entitiesModel.authors.size());
                _this.createLogForEntityLoaded('Categories', _this.entitiesModel.categories.size());
            });
        };
        DataProviderController.prototype.createLogForEntityLoaded = function (entity, quantity) {
            var log = Instrumentation_1.default.getLog("quantityOf" + entity);
            log.setParameters({
                activity: "Quantity of " + entity,
                instanceCount: quantity,
            });
            log.submit();
        };
        DataProviderController.prototype.getFileById = function (fileId) {
            if (fileId) {
                return this.files.getFileById(fileId);
            }
            return;
        };
        DataProviderController.prototype.fetchFilesData = function (fileIds) {
            this.files.fetch({
                data: { fileIds: JSON.stringify(fileIds) },
                remove: false,
            });
        };
        return DataProviderController;
    }());
    exports.DataProvider = DataProviderController.instance;
});
